import React, { useState, useEffect } from "react";
import styles from "./PrivacyPolicy.module.css";
import { OPEN_PRIVACY_POLICY } from "../utils/cookieEvents";

export default function PrivacyPolicy({ onClose }) {
  const [isOpen, setIsOpen] = useState(false);

  // 🔸 nasłuchujemy eventu z Footer
  useEffect(() => {
    const handleOpen = () => setIsOpen(true);
    window.addEventListener(OPEN_PRIVACY_POLICY, handleOpen);
    return () => window.removeEventListener(OPEN_PRIVACY_POLICY, handleOpen);
  }, []);

  if (!isOpen) return null; // jeśli nie otwarte — nic nie renderujemy

  return <div className={styles.overlay} onClick={e => {
        if (e.target === e.currentTarget) onClose();
      }}>
      <div className={styles.privacyModalContent} role="document">
        <h2 className={styles.privacyModalTitle}>Polityka prywatności</h2>
        <div className={styles.modalBody}>
          <div className={styles.pointOfPrivacyPolicy}>
            <h2 className={styles.titlePoint}>
              1. Kto jest administratorem Państwa danych osobowych?
            </h2>
            <p className={styles.policyPrivacyDescription}>
              Administratorem Państwa danych osobowych jest firma Nazwa firmy. Z
              administratorem możesz skontaktować się poprzez formularz
              kontaktowy na stronie lub bezpośrednio e-mailem:
              e-mail firmy.
            </p>
          </div>
          <div className={styles.pointOfPrivacyPolicy}>
            <h2 className={styles.titlePoint}>2. Jakie dane zbieramy.</h2>
            <p className={styles.policyPrivacyDescription}>
              Zbieramy dane przekazane dobrowolnie przez użytkowników, w tym:
              imię, nazwisko, adres e-mail i numer telefonu (jeśli wpiszesz je
              w formularzu kontaktowym), informacje automatycznie zbierane
              przez narzędzia analityczne, takie jak Google Analytics (np.
              adres IP, typ urządzenia, odwiedzane podstrony) oraz GoogleAds
              (np. kliknięcia w reklamy).
            </p>
          </div>
          <div className={styles.pointOfPrivacyPolicy}>
            <h2 className={styles.titlePoint}>
              3. W jakim celu przetwarzamy Państwa dane.
            </h2>
            <p className={styles.policyPrivacyDescription}>
              Pańswta dane wykorzystujemy: aby odpowiedzieć na Państwa
              zapytanie przesłane przez formularz kontaktowy lub e-mail, aby
              analizować ruch na stronie i usprawniać jej działanie (Google
              Analytics), aby prowadzić działania reklamowe (Google Ads, w
              przyszłości social media).
            </p>
          </div>
          <div className={styles.pointOfPrivacyPolicy}>
            <h2 className={styles.titlePoint}>
              4. Podstawa prawna przetwarzania.
            </h2>
            <p className={styles.policyPrivacyDescription}>
              Dane przetwarzane są na podstawie: art. 6 ust. 1 lit. f RODO –
              uzasadniony interes administratora (kontakt i odpowiedź na
              zapytanie), art. 6 ust. 1 lit. a RODO – Twoja zgoda (np. na
              pliki cookies analityczne i marketingowe).
            </p>
          </div>
          <div className={styles.pointOfPrivacyPolicy}>
            <h2 className={styles.titlePoint}>5. Komu udostępniamy dane.</h2>
            <p className={styles.policyPrivacyDescription}>
              Dane mogą być przekazywane podmiotom, z których usług korzystamy
              przy obsłudze strony: Google Ireland Ltd. (Google Analytics,
              Google Ads), dostawca hostingu strony, firmy zapewniające
              obsługę IT i bezpieczeństwa.
            </p>
          </div>
          <div className={styles.pointOfPrivacyPolicy}>
            <h2 className={styles.titlePoint}>
              6. Formularz kontaktowy i przetwarzanie danych przez EmailJs
            </h2>
            <div className={styles.policyPrivacyDescription}>
              <h6>
                <strong>I. Formularz kontaktowy.</strong>
              </h6>
              <p className={styles.itemDescription}>
                W ramach formularza kontaktowego dostępnego na stronie
                internetowej Użytkownik może dobrowolnie przekazać swoje dane
                osobowe, takie jak: imię i nazwisko, adres e-mail, numer
                telefonu, treść wiadomości. Podanie danych jest dobrowolne,
                lecz niezbędne do przesłania zapytania i umożliwienia
                odpowiedzi.
              </p>

              <h6>
                <strong>II. Cel i podstawa prawna przetwarzania.</strong>
              </h6>
              <p className={styles.itemDescription}>
                Dane osobowe przekazane za pośrednictwem formularza
                kontaktowego są przetwarzane w celu: udzielenia odpowiedzi na
                przesłane zapytanie, przedstawienia oferty handlowej, jeżeli
                Użytkownik o to poprosi. Podstawą prawną przetwarzania danych
                jest: art. 6 ust. 1 lit. b RODO – niezbędność do podjęcia
                działań na żądanie osoby, której dane dotyczą, przed zawarciem
                umowy, art. 6 ust. 1 lit. f RODO – prawnie uzasadniony interes
                administratora polegający na prowadzeniu korespondencji
                związanej z działalnością gospodarczą, w przypadku zgody
                marketingowej: art. 6 ust. 1 lit. a RODO.
              </p>

              <h6>
                <strong>III.Korzystanie z usługi EmailJS.</strong>
              </h6>
              <p className={styles.itemDescription}>
                W celu obsługi wiadomości wysyłanych z formularza kontaktowego korzystamy z zewnętrznej usługi EmailJS, świadczonej przez EmailJS Ltd. Usługa umożliwia automatyczne przesyłanie wiadomości e-mail bez konieczności uruchamiania własnego serwera pocztowego. W ramach działania formularza dane użytkownika (takie jak imię i nazwisko, adres e-mail, numer telefonu oraz treść wiadomości) są przesyłane do EmailJS wyłącznie w celu technicznej realizacji wysyłki wiadomości. EmailJS może przetwarzać dane na serwerach zlokalizowanych poza Unią Europejską. W takim przypadku przetwarzanie odbywa się zgodnie z przepisami RODO, na podstawie odpowiednich zabezpieczeń prawnych, takich jak standardowe klauzule umowne (SCC). EmailJS nie wykorzystuje przekazanych danych do własnych celów marketingowych i nie przekazuje ich dalej innym podmiotom poza koniecznymi procesami technicznymi związanymi ze świadczeniem usługi.
                {/* <a href="https://policies.google.com/privacy" target="_blank" className={styles.colorInModal}>
                  <strong> Polityce prywatności Google</strong>
                </a> */}
              </p>

              <h6>
                <strong>IV.Okres przechowywania danych.</strong>
              </h6>
              <p className={styles.itemDescription}>
                Dane osobowe przekazane za pośrednictwem formularza
                kontaktowego są przechowywane przez okres niezbędny do
                udzielenia odpowiedzi i zakończenia korespondencji. W
                przypadku zapytań ofertowych dane mogą być przechowywane do
                czasu przedawnienia ewentualnych roszczeń wynikających z
                prowadzonej korespondencji lub ustalenia, dochodzenia czy
                obrony roszczeń. W przypadku wyrażenia zgody marketingowej
                dane są przechowywane do czasu jej wycofania. Po upływie
                wskazanych okresów dane są usuwane z systemów administratora
                oraz z systemów wykorzystywanych do obsługi technicznej
                wysyłki wiadomości, w tym z systemu EmailJS, o ile zostały tam
                zapisane zgodnie z konfiguracją usługi.
              </p>

              <h6>
                <strong>V.Odbiorcy danych.</strong>
              </h6>
              <p className={styles.itemDescription}>
                Dane osobowe mogą być przekazywane:
                <ul>
                  <li>
                    podmiotom świadczącym usługi hostingu oraz obsługi poczty
                    elektronicznej wykorzystywanej przez administratora,
                  </li>
                  <li>
                    firmie EmailJS Ltd. – jako dostawcy usługi EmailJS,
                    wykorzystywanej wyłącznie do technicznej realizacji
                    wysyłki wiadomości z formularza kontaktowego,
                  </li>
                  <li>
                    podmiotom współpracującym z administratorem w zakresie
                    wsparcia technicznego i IT, które posiadają stosowne
                    uprawnienia do przetwarzania danych,
                  </li>
                  <li>
                    innym podmiotom uprawnionym do ich otrzymania na podstawie
                    przepisów prawa.
                  </li>
                </ul>
                EmailJS nie wykorzystuje danych użytkownika do własnych celów, nie udostępnia ich osobom trzecim i przetwarza je wyłącznie w zakresie niezbędnym do realizacji usługi.
              </p>

              <h6>
                <strong>VI.Prawa osoby, której dane dotyczą.</strong>
              </h6>
              <p className={styles.itemDescription}>
                Użytkownik ma prawo do: dostępu do swoich danych,
                sprostowania, usunięcia lub ograniczenia przetwarzania,
                wniesienia sprzeciwu wobec przetwarzania, przenoszenia danych,
                cofnięcia zgody w dowolnym momencie, wniesienia skargi do
                Prezesa Urzędu Ochrony Danych Osobowych (UODO).
              </p>
            </div>
          </div>
          <div className={styles.pointOfPrivacyPolicy}>
            <h2 className={styles.titlePoint}>
              7. Jak długo przechowujemy Państwa dane.
            </h2>
            <p className={styles.policyPrivacyDescription}>
              Dane z formularza kontaktowego przechowujemy maksymalnie przez
              12 miesięcy od zakończenia korespondencji. Dane statystyczne (z
              cookies) – zgodnie z ustawieniami przeglądarki lub do czasu
              cofnięcia zgody.
            </p>
          </div>
          <div className={styles.pointOfPrivacyPolicy}>
            <h2 className={styles.titlePoint}>
              8. Prawa, które Państwu przysługują.
            </h2>
            <p className={styles.policyPrivacyDescription}>
              Macie Państwo prawo do: dostępu do swoich danych, ich
              sprostowania lub usunięcia, ograniczenia przetwarzania,
              sprzeciwu wobec przetwarzania, przeniesienia danych, cofnięcia
              zgody w dowolnym momencie. W tym celu mogą Państwo skontaktować
              się z nami przez e-mail: e-mail firmy
            </p>
          </div>
          <div className={styles.pointOfPrivacyPolicy}>
            <h2 className={styles.titlePoint}>9. Pliki cookies.</h2>
            <p className={styles.policyPrivacyDescription}>
              Strona wykorzystuje pliki cookies: niezbędne do działania (techniczne), analityczne (Google Analytics), marketingowe (Google Ads, w przyszłości social media). Użytkownik może w każdej chwili zmienić swoje preferencje za pomocą linku w stopce strony głównej. Szczegółowe informacje na temat plików cookies znajdują się w naszej polityce cookies.
              {/* <a href="#" target="_blank" className={styles.colorInModal}>
                <strong> Polityka cookies</strong>
              </a> */}
            </p>
          </div>
          <div className={styles.pointOfPrivacyPolicy}>
            <h2 className={styles.titlePoint}>
              10. Zmiany w polityce cookies.
            </h2>
            <p className={styles.policyPrivacyDescription}>
              Polityka prywatności może być aktualizowana np. w przypadku
              zmian technologicznych lub prawnych. Aktualna wersja dokumentu
              jest zawsze dostępna na stronie internetowej.
            </p>
          </div>
        </div>

        <div className={styles.actions}>
          <button onClick={() => setIsOpen(false)} className={styles.privacyBtn}>
            Zamknij
          </button>
        </div>
      </div>
    </div>;
}
